/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { signupCompanyInfoStepSegment } from "@well/navigation";
import { CompanyType } from "@well/common-libs/legal-entity-management/domain-model";
import { translationSchema } from '@well/translation';
import { EnvironmentService } from '@irian-ro/util-environment';

@Component({
  selector: 'well-choose-account-type',
  templateUrl: './choose-account-type.component.html',
  styleUrls: ['./choose-account-type.component.scss'],
})
export class ChooseAccountTypeComponent {

  companyType = CompanyType;
  environmentService = inject(EnvironmentService);

  constructor(private router: Router,
              private route: ActivatedRoute) {
  }

  onNextStep(event: CompanyType){
    this.router.navigate([`../${signupCompanyInfoStepSegment}`, event], {relativeTo: this.route})
  }

  protected readonly translationSchema = translationSchema;
}
